import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import React, { useEffect, useState } from "react";
import handleZoom from "utils/handleZoom";
import getEsriSpatialData from "context/contextFunctions/getEsriSpatialData";
import MunsAccordion from "components/MunsAccordion";

export default function JobZoneDetails() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();

  const [munsList, setMunsList] = useState([]);

  const {
    selectedJobZoneforDetails,
    polesLayer,
    view,
    graphicsLayer,
    sketchLayer,
    bufferLayer,
    jobZonesGraphicLayer,
    polesList,
  } = map;

  const handleBack = () => {
    dispatchMap({
      type: "INIT",
      payload: {
        polesSelectionComponentMode: "jobZoneList",
        selectedJobZoneforDetails: null,
        polesList: [],
        selectionGeometry: null,
      },
    });
    graphicsLayer.removeAll();
    sketchLayer.removeAll();
    bufferLayer.removeAll();
    jobZonesGraphicLayer.removeAll();
  };

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        if (polesLayer && view && token && selectedJobZoneforDetails) {
          const munQuery = selectedJobZoneforDetails.Selected_Mun;

          handleZoom([selectedJobZoneforDetails], view, jobZonesGraphicLayer);
          const featureFilter = {
            // autocasts to FeatureFilter
            geometry: selectedJobZoneforDetails.geometry,
            spatialRelationship: "intersects",
          };

          if (polesLayer) {
            const { res: newPolesRes } = await getEsriSpatialData({
              ...featureFilter,
              returnGeometry: true,
              view,
              outFields: "*",
              featureLayer: polesLayer,
              query:
                !munQuery || munQuery === "1=1"
                  ? "Status IS NULL"
                  : `${munQuery} AND Status IS NULL`,
              neededDomains: ["Pole_Type"],
            });

            // handleZoom(newPolesRes, view, graphicsLayer);
            dispatchMap({
              type: "INIT",
              payload: {
                polesList: newPolesRes,
              },
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, selectedJobZoneforDetails, polesLayer]);

  useEffect(() => {
    if (polesList?.length) {
      const allMuns = polesList?.map((unit) => unit.Municipality);
      const uniqueMunsList = Array.from(new Set(allMuns));
      setMunsList(uniqueMunsList);
    }
    if (!polesList?.length) {
      setMunsList([]);
    }
  }, [polesList]);

  return (
    <div className="meters" style={{ position: "relative" }}>
      <div className="btn_group mb-3">
        <button
          type="button"
          className="btn btn--icon btn--outline--primary"
          onClick={handleBack}
          style={{ height: "50px" }}
        >
          <i className="fa-solid fa-arrow-left end" />
          Back
        </button>
      </div>
      {munsList?.length ? (
        munsList?.map((mun) => (
          <MunsAccordion
            // toggleUnselectMunDialog={toggleUnselectMunDialog}
            item={mun}
            polesList={polesList}
            key={mun}
            selectionGeometry={selectedJobZoneforDetails.geometry}
            zoneName={selectedJobZoneforDetails.Zone_Name}
          />
        ))
      ) : (
        <div style={{ color: "grey" }}>
          <div
            className="text-center"
            style={{ marginBottom: "40px", fontSize: "20px" }}
          >
            No Results Found{" "}
          </div>
        </div>
      )}
    </div>
  );
}
